import React, { Component, PropTypes } from 'react';

class ConfigurationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dummy: false
        };
    }

    render() {
        const fields = this.props.fields;
        return (
            <div className="spark-panel__content col-lg-12">
                {fields.map(elem => {
                    return (
                        <div key={elem.name} className="spark-panel spark-panel--card col-lg-12 col-xs-12 col-sm-6 row">
                            <div className="spark-panel__content spark-expand col-lg-12 row">
                                <h6 className="col-lg-4">{elem.name}</h6>
                                <div className="col-lg-4" />
                                {this.props.filterList.find(element => {
                                    return element === elem.code;
                                }) ? (
                                    <a
                                        disabled={this.props.isDisabled}
                                        className="col-lg-2 spark-icon-password-view spark-icon-lg"
                                        onClick={() => {
                                            this.props.makeVisibleFilters(this.props.filterType, elem.code);
                                            this.setState({ dummy: !this.state.dummy });
                                        }}
                                    >
                                        {this.props.positive}
                                    </a>
                                ) : (
                                    <a
                                        className="col-lg-2 spark-icon-password-view spark-icon-lg"
                                        disabled={this.props.isDisabled}
                                        onClick={() => {
                                            this.props.makeInvisibleFilters(this.props.filterType, elem.code);
                                            this.setState({ dummy: !this.state.dummy });
                                        }}
                                    >
                                        {this.props.negative}
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

ConfigurationList.propTypes = {
    status: PropTypes.bool,
    isDefault: PropTypes.bool,
    onChange: PropTypes.func
    // arrayToChange: PropTypes.string.isRequired,
    // fieldName: PropTypes.string.isRequired
};

export default ConfigurationList;



// WEBPACK FOOTER //
// ./src/components/widgets/ConfigurationList.js